/* Shared by storefront hearts and Zoe. No app or account required. */
(() => {
  'use strict';
  if (window.AkaariWishlist) return;
  const KEY = 'akaari_wishlist';
  const LIMIT = 200;
  let memory = [];
  let persistent = true;
  function normalise(value) {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9_-]{0,200}$/i.test(item.handle))
      .filter(item => { if (seen.has(item.handle)) return false; seen.add(item.handle); return true; })
      .slice(0, LIMIT).map(item => ({
        handle: item.handle,
        name: String(item.name || item.handle).slice(0, 300),
        variantId: /^\d+$/.test(String(item.variantId || '')) ? String(item.variantId) : null,
        addedAt: typeof item.addedAt === 'string' ? item.addedAt.slice(0, 40) : new Date().toISOString()
      }));
  }
  function get() {
    if (!persistent) return memory.map(item => ({ ...item }));
    try {
      memory = normalise(JSON.parse(localStorage.getItem(KEY) || '[]'));
    } catch (error) {
      if (!(error instanceof SyntaxError)) persistent = false;
      else memory = [];
    }
    return memory.map(item => ({ ...item }));
  }
  function replace(value) {
    const before = get();
    const next = normalise(value);
    try { localStorage.setItem(KEY, JSON.stringify(next)); persistent = true; }
    catch (_) { persistent = false; }
    memory = next;
    document.dispatchEvent(new CustomEvent('akaari:wishlist-change', { detail: { items: get(), persistent } }));
    for (const item of next) {
      if (!before.some(old => old.handle === item.handle)) {
        document.dispatchEvent(new CustomEvent('akaari:wishlist-add', { detail: { handle: item.handle } }));
      }
    }
    return { ok: true, persistent };
  }
  function add(item) {
    const clean = normalise([item])[0];
    if (!clean) return { ok: false, reason: 'invalid' };
    const list = get();
    const index = list.findIndex(entry => entry.handle === clean.handle);
    if (index < 0 && list.length >= LIMIT) return { ok: false, reason: 'limit' };
    if (index >= 0) list[index] = clean;
    else list.push(clean);
    return replace(list);
  }
  function remove(handle) { return replace(get().filter(item => item.handle !== handle)); }
  window.AkaariWishlist = { get, add, remove, replace, has: handle => get().some(item => item.handle === handle), isPersistent: () => persistent };
  window.addEventListener('storage', event => {
    if (event.key !== KEY && event.key !== null) return;
    persistent = true;
    document.dispatchEvent(new CustomEvent('akaari:wishlist-change', { detail: { items: get(), persistent } }));
  });
})();
